<p>indsms-vertical-component works!</p>
